/**
 * MEGA MENU V2 — hover/open controller
 * Ported from par-breaker-megamenu.html design export.
 */
(function () {
  var CLOSE_DELAY = 150; // grace period so a diagonal mouse path doesn't drop the panel

  // ---- sticky on scroll ----
  // Same pattern as sections/pdp-sticky-nav.liquid's .pdp-nav-bar: measure
  // the header's natural top-of-page offset once, then once scrollY reaches
  // that point, switch it to position: fixed (see .pb-header-outer.is-stuck
  // in mega-menu-v2.css) so it stops right where it hit the viewport top
  // instead of continuing to scroll away. A placeholder div holds its
  // vacated space so content below doesn't jump.
  (function initSticky() {
    var header = document.querySelector('.pb-header-outer[data-pb-megamenu]');
    if (!header) return;

    var placeholder = document.createElement('div');
    header.parentNode.insertBefore(placeholder, header);
    placeholder.style.display = 'none';

    var headerTop = null;
    var stuck = false;

    function getHeaderTop() {
      if (!stuck) {
        headerTop = header.getBoundingClientRect().top + window.pageYOffset;
      }
    }

    function pdpSubNavIsStuck() {
      // sections/pdp-sticky-nav.liquid pins its own bar (.pdp-nav-bar) on
      // top of this one (z-index: 300 vs. this header's 50) once scrolled
      // to it. While that's the case this header is fully hidden behind it,
      // so this placeholder shouldn't also be reserving page-flow space —
      // that double reservation is what left a grey gap below the white bar.
      return !!document.querySelector('.pdp-nav-bar.is-stuck');
    }

    function syncPlaceholderHeight() {
      placeholder.style.height = pdpSubNavIsStuck() ? '0px' : header.offsetHeight + 'px';
    }

    function onScroll() {
      if (headerTop === null) return;
      var shouldBeStuck = window.scrollY >= headerTop;
      if (shouldBeStuck && !stuck) {
        stuck = true;
        placeholder.style.display = 'block';
        header.classList.add('is-stuck');
        syncPlaceholderHeight(); // set immediately, no one-frame collapsed flash
      } else if (!shouldBeStuck && stuck) {
        stuck = false;
        header.classList.remove('is-stuck');
        placeholder.style.display = 'none';
      }
      // Deferred a frame so it reads the PDP sub-nav's .is-stuck state after
      // that section's own scroll handler has run on this same scroll
      // event, regardless of which script's listener was registered first.
      if (stuck) requestAnimationFrame(syncPlaceholderHeight);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      getHeaderTop();
      if (stuck) syncPlaceholderHeight();
    });

    if (document.readyState === 'complete') {
      getHeaderTop();
      onScroll();
    } else {
      window.addEventListener('load', function () {
        getHeaderTop();
        onScroll();
      }, { once: true });
    }
  })();

  document.querySelectorAll('[data-pb-megamenu]').forEach(function (root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-pb-cat]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pb-panel]'));
    var timer = null;
    var pinned = false; // true once a panel is pinned open (e.g. landed here via a nav link)

    function paint(cat) {
      links.forEach(function (l) {
        var on = l.getAttribute('data-pb-cat') === cat;
        l.classList.toggle('is-active', on);
        l.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-open', p.getAttribute('data-pb-panel') === cat);
      });
    }

    function open(cat, isPin) {
      clearTimeout(timer);
      paint(cat);
      // A plain hover/focus never un-pins — once pinned (by a click, or by
      // landing on a category's own page), it stays pinned across hovering
      // to other labels too, until an explicit close (click-away, Escape).
      if (isPin) pinned = true;
    }
    function close(now) {
      clearTimeout(timer);
      pinned = false;
      if (now) { paint(null); return; }
      timer = setTimeout(function () { paint(null); }, CLOSE_DELAY);
    }

    links.forEach(function (link) {
      var cat = link.getAttribute('data-pb-cat');
      link.addEventListener('mouseenter', function () { open(cat); });
      link.addEventListener('focus', function () { open(cat); });
      link.addEventListener('click', function (e) {
        // Every top-level label is a pure dropdown toggle — it never navigates
        // on click, only via links inside its panel. The href stays so
        // right-click / middle-click / "open in new tab" still reach the
        // category's landing page. A click always opens and pins the panel —
        // it never closes it, since aria-expanded may already read "true"
        // from a hover that opened it moments earlier; closing is left to
        // click-away, Escape, or hovering to a different label.
        e.preventDefault();
        open(cat, true);
      });
    });

    root.addEventListener('mouseleave', function () {
      if (pinned) return; // a pinned panel only closes on click-away, not mouseleave
      close();
    });
    root.addEventListener('mouseenter', function () { clearTimeout(timer); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      close(true);
      var active = links.filter(function (l) { return l.classList.contains('is-active'); })[0];
      if (active) active.focus();
    });

    // close when focus leaves the header entirely (keyboard users)
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) close();
    });

    // clicking anywhere outside the mega menu closes it, including a pinned panel
    document.addEventListener('click', function (e) {
      if (root.contains(e.target)) return;
      close(true);
    });
  });
})();
